<template>
    <div class="popup down rd-dialog rd-download rf-download" :class="classObj">
        <van-popup :value="show" @click-overlay="close">
            <button type="button" class="icon-close" :aria-label="$t('refresh.close')" @click="close">
                <RefreshIcon name="close"/>
            </button>
            <div class="content">
                <div class="info">
                    <img v-theme-art="logoUrl" v-if="logoUrl" class="logo" :src="logoUrl" @click.stop="refresh" /><span v-else class="rf-download-brand">{{ ($store.getters.sysConfig || {}).projectName || $t('downApp.Apps') }}</span>
                    <h1 class="title">{{ $t("refresh.downloadTitle") }}</h1><p class="rf-download-intro">{{ ($store.getters.sysConfig || {}).projectName ? $t("refresh.downloadIntro", { project: $store.getters.sysConfig.projectName }) : $t("refresh.downloadIntroGeneric") }}</p>
                </div>
                <div class="btns">
                    <button type="button" class="item rf-download-quick" @click="$refs.SaveVersionPopup.open()"><span class="rf-app-icon"><RefreshIcon name="download"/></span><span class="rf-version-copy"><strong class="txt">{{ $t('downApp.QuickVersion') }}</strong><span class="rf-version-desc">{{ $t('refresh.downloadQuickIntro') }}</span></span><span class="size">3.8M</span></button>
                    <button type="button" class="item" @click="onDownApp(systemConfig.apkUrl)"><span class="rf-app-icon"><RefreshIcon name="download"/></span><span class="rf-version-copy"><strong class="txt">{{ $t('downApp.NormalVersion') }}</strong><span class="rf-version-desc">{{ $t('refresh.downloadNormalIntro') }}</span></span><span class="size">28.8M</span></button>
                </div>
            </div>
        </van-popup>
        <SaveVersionPopup ref="SaveVersionPopup" :isToHome="false"></SaveVersionPopup>
    </div>
</template>

<script>
import SaveVersionPopup from '@/views/downAppPWA/modules/SaveVersionPopup'
import { getApkUrl } from '@/api/pwa'
import { mapState } from 'vuex'
export default {
    components: {
        SaveVersionPopup
    },
    data() {
        return {
            systemConfig: {}
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        show: {
            get() {
                return this.$store.getters.isShowDownAppPopup
            },
            set(val) {
                return val
            }
        }
    },
    created() {
        getApkUrl().then((res) => {
            if (res.code) return
            const D = res.result
            this.systemConfig = D
            this.$store.dispatch('system/setApkUrl', D.apkUrl)
        })
    },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowDownAppPopup', false)
        },
        onDownApp(url) {
            window.open(url)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    &.mobile{
        .icon-close {
            top: auto;
            bottom: -.88rem;
            right: calc(50% - .34rem);
        }
    }

    &.down{
        .van-popup {
            background: transparent;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            overflow: visible !important;
        }
    }
    .icon-close {
        position: absolute;
        top: 0;
        right: -.88rem;
        width: .68rem;
        height: .68rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .06rem;
        cursor: pointer;
        background: var(--theme-popup-close-bg);
        border: .01rem solid var(--theme-popup-close-border);

        i {
            font-size: .28rem;
             color: var(--theme-bright-text);font-weight: bold;
        }
    }

    .content {
        width: 94vw;
        max-width: 360px;
        border-radius: .32rem;
        box-sizing: border-box;
        border: .01rem solid transparent;
        background-image:
            linear-gradient(to right, var(--theme-popup-box-bg), var(--theme-popup-box-bg)),
            linear-gradient(90deg, var(--theme-popup-box-border), var(--theme-popup-box-border));
        background-origin: border-box;
        background-clip: content-box, border-box;
        box-shadow: var(--theme-popup-box-shadow);
        box-sizing: border-box;
        position: relative;
        overflow: auto;

        .info {
            padding: .38rem;
            margin-bottom: .98rem;

            .logo {
                width: auto;
                height: .98rem;
                margin: 0 auto;
                display: block;
                margin-bottom: .18rem;
            }

            .title {
                width: 100%;
                color: $font-component-cool-color;
                line-height: .38rem;
                text-align: center;
                font-size: .36rem;
                margin-top: .08rem;
            }
        }

        .btns {
            height: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: .2rem;
            margin-bottom: .8rem;

            &>div.item {
                width: calc(50% - .35rem);
                display: flex;
                align-items: center;
                flex-direction: column;
                padding: 0;
                border-radius: .18rem;
                cursor: pointer;
                box-sizing: border-box;
                border: .01rem solid transparent;
                background-image:
                    linear-gradient(to right, var(--theme-popup-panel-fill), var(--theme-popup-panel-fill)),
                    var(--theme-popup-panel-border);
                background-origin: border-box;
                background-clip: content-box, border-box;
                box-shadow: var(--theme-popup-box-shadow);
                position: relative;

                .item__img {
                    width: 1.5rem;
                    height: 1.28rem;
                    flex-shrink: 0;
                    vertical-align: middle;
                    margin-top: -.48rem;
                }

                .txt {
                    font-style: normal;
                    font-size: .32rem;
                     color: var(--theme-bright-text);line-height: 1.2;
                    margin-bottom: .04rem;
                    margin-top: .1rem;
                }

                .size {
                    color: var(--theme-list-row-border);
                    font-size: .2rem;
                    margin-bottom: .3rem;
                }

                &.act {
                    background-image:
                        linear-gradient(to right, var(--theme-popup-panel-fill), var(--theme-popup-panel-fill)),
                        var(--theme-popup-panel-border);
                }
            }
        }
    }
}
</style>
